import { useContext, useEffect, useState } from "react";
import { AuthContext } from "context/AuthContext";
import Switch from "react-switch";
import _ from "lodash";
import useSWR from "swr";
import { fetchWithParams } from "lib/fetcher";
import { SvgToastInfo } from "ui/svgs";
import { Tooltip } from "react-tooltip";

export default function Action({ actions, setActions }) {
  const { user } = useContext(AuthContext);
  //const { actions, setActions } = useContext(AutomationContext);
  const [emailEnable, setEmailEnable] = useState(false);
  const [messageEnable, setMessageEnable] = useState(false);

  useEffect(() => {
    if (actions?.length > 0) {
      const action = actions[0];
      if (action?.notifiers?.ownerNotifier?.types?.includes("email")) {
        setEmailEnable(true);
      } else {
        setEmailEnable(false);
      }
      if (action?.notifiers?.ownerNotifier?.types?.includes("sms")) {
        setMessageEnable(true);
      } else {
        setMessageEnable(false);
      }
    }
  }, [actions]);

  const updateActions = (emailEnable, messageEnable) => {
    if (actions?.length > 0) {
      let action = actions[0];
      let types = action?.notifiers?.ownerNotifier?.types;
      if (!types) {
        action = { notifiers: { ownerNotifier: { types: [] } } };
        types = [];
      }

      if (!emailEnable) {
        types = types.filter((type) => type !== "email");
      } else if (!types.includes("email")) {
        types.push("email");
      }

      if (!messageEnable) {
        types = types.filter((type) => type !== "sms");
      } else if (!types.includes("sms")) {
        types.push("sms");
      }

      action.notifiers.ownerNotifier.types = types;
      setActions(_.cloneDeep([action]));
    } else {
      const types = [];
      emailEnable && types.push("email");
      messageEnable && types.push("sms");
      actions.push({
        notifiers: {
          ownerNotifier: {
            types: types,
          },
        },
      });
      setActions(_.cloneDeep(actions));
    }
  };

  return (
    <div className="w-full h-full py-8">
      <div className="w-full p-6 rounded-3xl bg-zinc-50">
        <div className="flex items-center justify-between mb-1">
          <div className="flex items-center gap-1 ">
            <span className="font-semibold">Email</span>
            <div
              className="hover:bg-gray-100 hover-bg-gray-100"
              data-tooltip-id="my-tooltip"
              data-tooltip-html={`<div><div>Email: ${user?.email}</div><div>Configured by your dealer.</div></div>`}
            >
              <Tooltip
                id="my-tooltip"
                className=" !text-white !rounded-xl !shadow-xl"
              />
              <SvgToastInfo width="16" className="fill-neutral-500" />
            </div>
          </div>
          <Switch
            onChange={() => {
              setEmailEnable(!emailEnable);
              updateActions(!emailEnable, messageEnable);
            }}
            checked={emailEnable}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor="#3E83F6"
            offColor="#fff"
            handleDiameter={20}
            offHandleColor="#9E9E9E"
            className="border border-zinc-200"
            height={32}
            width={52}
          />
        </div>
      </div>
      <div className="mt-8 w-full p-6 rounded-3xl bg-zinc-50">
        <div className="flex items-center justify-between  mb-1">
          <div className="flex items-center gap-1 ">
            <span className="font-semibold">Text Message</span>
            <div
              className="hover:bg-gray-100 hover-bg-gray-100"
              data-tooltip-id="my-tooltip"
              data-tooltip-html={`<div><div>Phone Number: ${user?.phoneNumber}</div><div>Configured by your dealer.</div></div>`}
            >
              <Tooltip
                id="my-tooltip"
                className=" !text-white !rounded-xl !shadow-xl"
              />
              <SvgToastInfo width="16" className="fill-neutral-500" />
            </div>
          </div>
          <Switch
            onChange={() => {
              setMessageEnable(!messageEnable);
              updateActions(emailEnable, !messageEnable);
            }}
            checked={messageEnable}
            uncheckedIcon={false}
            checkedIcon={false}
            onColor="#3E83F6"
            offColor="#fff"
            handleDiameter={20}
            offHandleColor="#9E9E9E"
            className="border border-zinc-200"
            height={32}
            width={52}
          />
        </div>
      </div>
    </div>
  );
}
